/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { AbstractControl, ValidatorFn } from '@angular/forms'
import { parsePhoneNumber } from 'awesome-phonenumber'

export function phoneValidator(countryCode: string): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (!control.value) {
      return null
    }
    let phoneNumber = parsePhoneNumber(control.value)
    if (countryCode) {
      phoneNumber = parsePhoneNumber(control.value, { regionCode: countryCode })
    }

    if (!phoneNumber.valid) {
      return { phoneValidation: true }
    }

    if (control?.parent?.get('phoneType')?.value === 'mobile') {
      if (!phoneNumber.typeIsMobile) {
        return { phoneValidation: true }
      }
    } else if (control?.parent?.get('phoneType')?.value === 'landline') {
      if (!phoneNumber.typeIsFixedLine) {
        return { phoneValidation: true }
      }
    }

    return null
  }
}
